<template>
    <ValidationObserver v-slot="{ invalid, validated, passes, validate, handleSubmit }" ref="observer">

        <v-dialog v-model="dialog" max-width="700px" :fullscreen="$vuetify.breakpoint.mdAndDown || dialogFullScreen"
                  :hide-overlay="$vuetify.breakpoint.mdAndDown" scrollable
                  no-click-animation>
            <v-card>
                <v-toolbar dark color="primary" :max-height="$vuetify.breakpoint.mdAndUp ? 64 : 56">
                    <v-btn icon dark @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Maintenance</v-toolbar-title>
                    <v-progress-linear
                            :active="saveLoading"
                            :indeterminate="saveLoading"
                            absolute
                            bottom
                            color="lime"
                    ></v-progress-linear>
                    <div class="flex-grow-1"></div>
                    <v-toolbar-items>
                        <v-btn v-if="$vuetify.breakpoint.mdAndUp" icon @click="dialogFullScreen = !dialogFullScreen">
                            <v-icon v-if="dialogFullScreen === true">mdi-fullscreen-exit</v-icon>
                            <v-icon v-if="dialogFullScreen === false">mdi-fullscreen</v-icon>
                        </v-btn>
<!--                        <v-btn dark text @click="passes(submit)">-->
<!--                            <v-icon>mdi-content-save-outline</v-icon>-->
<!--                        </v-btn>-->
                    </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-5">
                  <b>Url actuelle :</b> {{ actualUrl }} <br>
                  <v-text-field v-if="newUrl" disabled v-model="newUrl" label="Nouvelle URL" placeholder="Entrez une URL" class="mt-3">
                    <template v-slot:append>
                      <v-btn v-if="newUrl" color="primary" text @click="changeUrl()" small>Charger</v-btn>
                    </template>
                  </v-text-field>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Données de l'app
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <pre>{{ AppStore.data }}</pre>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels class="mt-3">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Informations bdd locale
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <pre>{{ dbInfo }}</pre>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-btn @click="reloadApp()" class="mt-5">Recharger l'app</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </ValidationObserver>

</template>

<script>
import AppStore from "../../../stores/AppStore";
import {ValidationObserver} from 'vee-validate';
import _ from "lodash";
import ModelLogic from "../../../logics/ModelLogic";

export default {
  name: 'maintenance-dialog',

  props: {},

  components: {
    ValidationObserver,
  },

  data: () => ({
    dialog: false,
    dialogFullScreen: false,
    saveLoading: false,
    dbInfo : {},
    newUrl : '',
    AppStore
  }),

  created() {
  },

  mounted() {
    this.getDbInfos()
  },

  computed: {
    actualUrl() {
      return window.location.href
    }
  },

  watch: {},

  methods: {
    openDialog() {
      return new Promise(resolve => {
        // this.loading = true;

        this.dialog = true;
        resolve()
      })
    },

    closeDialog() {
      return new Promise(resolve => {
        this.dialog = false;
        resolve()
      })
    },

    submit() {
      this.saveLoading = true;

      // ModelLogic
      //     .attach('units-groups', UnitGroupStore.unitGroup.id, 'units', this.selected)
      //     .then((model) => {
      //         this.$emit('update-unit', model)
      //         this.saveLoading = false;
      //         this.selected = [];
      //         this.closeDialog()
      //     })
      //     .catch((err) => {
      //         this.saveLoading = false;
      //         console.error(err)
      //     })
    },

    getDbInfos(){
      AppStore.db.allDocs({
        include_docs: true,
        // attachments: true
      }).then((ratings) => {
        this.dbInfo = ratings;
        this.newUrl = AppStore.data.general.update_url
      }).catch((err) => {
        console.log(err);
        //TODO SEND ERROR MESSAGE
      });
    },

    changeUrl() {
      if (this.newUrl && this.newUrl.trim() !== '') {
        window.open(this.newUrl, '_blank');
      }
    },

    reloadApp(){
      window.location.reload()
    },
  },
};
</script>
